module.exports = __webpack_public_path__ + "static/media/gary-miller.bb5dca28.jpg";